import React from "react";
import { createUseStyles } from "react-jss";
import { LazyImage } from "react-lazy-images";
import { CDN_URL } from "Constants/CDN";

const useStyles = createUseStyles((theme) => ({
    imageElements: {
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        width: "100%",
        gap: "5px",
    },
    img: {
        height: "20px",
        maxWidth: "100%",
    }
}));

export const UnlimitedSocialGrey = ({ socialData }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.imageElements}>
                {socialData.map(({ key }, index) => {
                    return (
                        <LazyImage
                            src={`${CDN_URL}/images/social/grayscale/${key}.svg`}
                            placeholder={({ ref }) => (
                                <img ref={ref} className={classes.img} key={index} alt={key} />
                            )}
                            actual={({ imageProps }) => (
                                <img {...imageProps} className={classes.img} alt={key} />
                            )}
                        />
                    );
                })}
            </div>
        </div>
    );
};
